/**
 * Created by zhangrp on 2018/4/11.
 */
import api from './index'

let exports = {};
//

//我的报盘
exports.getDealReplyVoucherCountMapByFilter = function (callback) {
    api.post('/deal/reply/voucher/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//报价管理
exports.getPriceReplyVoucherCountMapByFilter = function (callback) {
    api.post('/price/reply/voucher/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//报名管理
exports.getBidEnrollCountMapByFilter = function (callback) {
    api.post('/tendBid/enroll/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//投标管理
exports.getBidDocCountMapByFilter = function (callback) {
    api.post('/tendBid/doc/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//发货单列表
exports.getGoodsShipVoucherCountMapByFilter = function (callback) {
    api.post('/goodsDeliv/ship/voucher/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//收款单据管理
exports.getRcvVoucherCountMapByFilter = function (callback) {
    api.post('/finac/rcv/voucher/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//退款单据管理
exports.getRefundVoucherCountMapByFilter = function (callback) {
    api.post('/finac/refund/voucher/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//佣金计费单列表
exports.getFundTransRecYjCountMapByFilter = function (callback) {
    api.post('/finac/fund/trans/rec/yj/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//开票与单据管理
exports.getInvoiceVoucherCountMapByFilter = function (callback) {
    api.post('/finac/invoice/voucher/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//自营服务订单管理
exports.getServcOrderCountMapByFilter = function (callback) {
    api.post('/servc/order/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//服务采购合同管理 | 集成采购合同管理 | 服务授权合同管理
exports.getContractCountMapByFilter = function (params, callback) {
    api.post('/contract/home/count/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

//我的应募列表
exports.getDistServcApplyFormCountMapByFilter = function (callback) {
    api.post('/servcDist/dist/servc/apply/form/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/workBench.js
// module id = 1432
// module chunks = 1